<template>
    <div class="index">
        <div class="flash">
            <div class="gg">
                <div><div class="topNav">解决方案</div></div>
                <div class="title">房地产行业</div>
                <div class="minTitle">地产行业具备商业属性，同时兼备民生保障属性，受政策影响较大；传统以圈地规模为导向的发展模式遇到瓶颈，逐渐向以精细运营为导向转型。</div>
                <!-- <div class="button">咨询详情</div> -->
            </div>
        </div>
       
       <picture>
        <source srcset="@/assets/images/dc1_mb.jpg" media="(max-width:768px)" alt="">
        <img class="flashImg" src="@/assets/images/dc1.png" />
        </picture>
       <div class="lxwm bg1">
            <div class="content">
                <div class="title1 tc">行业痛点</div>
                <div class="items mt5">
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/dc2.png" />
                            <div class="lb">
                                客户数据散
                            </div>
                        </div>
                        <div class="minTitle2 hs mt10">客户数据过于支离破碎, 企业不具备客户洞察能力, 难以“知己知彼”，难以提升增值服务。</div>
                    </div>
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/dc3.png" />
                            <div class="lb">
                                财务估算难
                            </div>
                        </div>
                        <div class="minTitle2 hs mt10">如何精准规划拿地投资，建筑成本/营销成本/费用成本/营销收入？</div>
                    </div>
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/dc4.png" />
                            <div class="lb">
                                融资渠道窄
                            </div>
                        </div>
                        <div class="minTitle2 hs mt10">融资渠道变窄，债项成本提升，如何有效提升有限资金周转率，降低融资成本？</div>
                    </div>
                    <div class="item2 item3">
                        <div class="tit">
                            <img src="@/assets/images/dc5.png" />
                            <div class="lb">
                                产品需求多样
                            </div>
                        </div>
                        <div class="minTitle2 hs mt10">客户对产品需求成多样化趋势，如何加速产品研发的标准化，数据化成为亟待解决问题。</div>
                    </div>
                </div>
            </div>
       </div>
       <div class="lxwm2 bg3">
            <div class="content">
                <div class="title1 tc">解决方案</div>
                <div class="items mt5">
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/dc6.png" />
                            <div class="lb">
                                客户分析
                            </div>
                        </div>
                        <div class="minTitle2 hs mt10">客户区域分析</div>
                        <div class="minTitle2 ">快速生成客户分布区域的图表，对潜在的区域客户进行分析，帮助企业快速识别细分区域市场，提出对潜在目标区域的客户有针对性的促销方案。</div>
                        <div class="minTitle2 hs mt10">客户画像分析</div>
                        <div class="minTitle2 ">快速针对高净值客户进行画像分析，帮助企业提出有针对性的对其进行产品推广和服务推荐，满足客户深层次的个性化的需求。</div>
                    </div>
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/dc7.png" />
                            <div class="lb">
                                角色能力培养能力
                            </div>
                        </div>
                        <div class="minTitle2 mt10">通过对企业各个项目的支出（成本和费用）及项目收入对比的分析，帮助企业识别优质项目，制定更好的项目投资和管理策略，让企业对各个项目的进展及健康程度一目了然。</div>
                        <div class="minTitle2 mt10">分析各个项目是否按计划要求在推进，帮助企业全面了解各个项目推进情况，进一步安排企业资源。</div>
                    </div>
                    <div class="item2 item3">
                        <div class="tit">
                            <img src="@/assets/images/dc8.png" />
                            <div class="lb">
                                资金流分析
                            </div>
                        </div>
                        <div class="minTitle2 mt10">通过时间轴的随意拉伸可以查看集团资金流在不同时间段的变化趋势，帮助企业更好的洞察资金流盈亏平衡，规避流动性风险。</div>
                        <div class="minTitle2 mt10">比较并展现不同不同城市的资金余额，帮助企业了解不同城市公司余额状况并为在集团内合理资金调拨提供依据。</div>
                        <div class="minTitle2 mt10">通过对比不同地区的费用支出，帮助企业更好的洞察不同地区费用差异，有针对性控制费率。</div>
                    </div>
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/dc9.png" />
                            <div class="lb">
                                营销分析
                            </div>
                        </div>
                        <div class="minTitle2 hs mt10">团队销售额统计</div>
                        <div class="minTitle2 ">通过统计对比不同项目和团队销售额，帮助企业识别高绩效销售团队。</div>
                        <div class="minTitle2 hs mt10">项目分布统计</div>
                        <div class="minTitle2 ">通过该客户不同级别地区的项目分布与行业平均数据做对比，帮助企业洞察区域拓展状况，识别区域拓展机会点，调整投资与拿地策略。</div>
                    </div>
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/dc10.png" />
                            <div class="lb">
                                全局管理驾驶舱
                            </div>
                        </div>
                        <div class="zoom">
                            <div class="left">
                                <div class="minTitle2 hs mt10">营销主题</div>
                                <div class="minTitle2">营销概览、销售分析测试测试</div>
                                <div class="minTitle2 hs mt10">成本主题</div>
                                <div class="minTitle2">项目成本、资金计划</div>
                                <div class="minTitle2 hs mt10">运营主题</div>
                                <div class="minTitle2">项目成本、资金计划测试测试</div>
                            </div>
                            <div class="right">
                                <div class="minTitle2 hs mt10">资金主题</div>
                                <div class="minTitle2">资金计划/日报</div>
                                <div class="minTitle2 hs mt10">人力主题</div>
                                <div class="minTitle2">薪酬福利、效能分析测试测试</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
       </div>
    </div>
</template>
<script>
    export default {
        components: {
        },
        data() {
            return {
                
            }
        },
        methods: {
            
        }
    }
</script>

<style lang="less" scoped>
    .index {
        .flashImg {
            width: 100%;
            height: calc(30w);
        }
        .bg3 {
            background-color: #efefef;
        }
        .lxwm {
            padding: 30px 0;
            .items {
                display: flex;
                flex-wrap: wrap;

                .item2 {
                    margin-top: 20px;
                    width: 19.49%;
                    background-color: #ffffff;
                    margin-right: 2%;
                    padding: 15px 2%;
                    min-height: 110px;
                    .hs {
                        color: #333333;
                    }
                    img {
                        height: 30px;
                        margin-right: 10px;
                    }
                    .lb {
                        display: inline-block;
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 35px;
                        vertical-align: bottom;
                    }
                    .minTitle2 {
                        line-height: 20px;
                    }
                }
                .item3 {
                    margin-right: 0;
                }
            }
            .mt40 {
                margin-top: 40px;
            }
            .conImg {
                width: 95%;
                height: auto;
            }
        }
        .lxwm2 {
            padding: 30px 0;
            
            .items {
                display: flex;
                flex-wrap: wrap;
                .item2 {
                    margin-top: 20px;
                    width: 27.33%;
                    background-color: #ffffff;
                    margin-right: 3%;
                    padding: 15px 2%;
                    min-height: 110px;
                    .zoom {
                        zoom: 1;
                        overflow: hidden;
                        .left {
                            float: left;
                            width: 47%;
                        }
                        .right {
                            float: right;
                            width: 47%;
                        }
                        .minTitle2 {
                            overflow:hidden;
                            white-space:nowrap;
                            text-overflow:ellipsis;
                            width: 120px;
                        }
                    }
                    img {
                        height: 30px;
                        margin-right: 10px;
                    }
                    .lb {
                        display: inline-block;
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 35px;
                        vertical-align: bottom;
                    }
                    .minTitle2 {
                        line-height: 20px;
                    }
                    .hs {
                        color: #333333;
                    }
                    .towLine {
                        line-height: 15px;
                        margin-top: 5px;
                    }
                }
                .item3 {
                    margin-right: 0;
                    
                }
            }
        }
    }
</style>
<style lang="less" scoped>
@media (max-width: 1230px) {
  .index {
    .flash {
      position: relative;
      padding: 0 50px;
      .gg .title {
        font-size: 24px;
      }
    }
    .flashImg {
      height: 100vh;
    }
    .items {
        .item2 {
            justify-content: space-between;
            width: 20%;
            margin-right: 0;
            padding: 15px 15px;
            .tit {
                display: flex;
                align-items: center;
            }
        }
    }
  }
}
@media (max-width: 960px) {
  .index {
    .flash {
      .gg {
        color: #fff;
        .title {
          font-size: 20px;
        }
        .minColor2 {
            color: #fff;
            border-color: #fff;
        }
        .minTitle {
          width: 100%;
          font-size: 13px;
        }
        .button {
          padding: 6px 15px;
          margin-top: 20px;
        }
      }
    }
    .lxwm {
        padding-bottom: 0;
        .title1 {
            margin-top: 0;
            margin-bottom: 0;
        }
        .items {
            .item2 {
                width: 100%;
                margin-right: 0;
                padding: 25px 15px;
                .minTitle2 {
                    line-height: 1.8;
                }
                .tit {
                    justify-content: center;
                }
                img {
                    height: 20px;
                }
                .lb {
                    line-height: normal;
                }
            }
            .minTitle2 {
                font-size: 14px;
            }
        }
    }
    .lxwm2 {
        background-color: #f6f8ff;
        .title1 {
            margin-top: 0;
            margin-bottom: 0;
        }
        .items {
            .item2 {
                width: 100%;
                margin-right: 0;
                padding: 25px 15px;
                .minTitle2 {
                    line-height: 1.8;
                }
                .tit {
                    justify-content: center;
                }
                img {
                    height: 20px;
                }
                .lb {
                    line-height: normal;
                }
                .zoom {
                    .left,.right {
                        width: 100%;
                    }
                    .minTitle2 {
                        width: 100%;
                    }
                }
            }
            .minTitle2 {
                font-size: 14px;
            }
        }
    }
  }
}
@media (max-width: 768px) {
    .index {
        .flash {
            padding: 0 15px;
            .minTitle {
                width: 50%;
                font-size: 13px;
                color: #fff;
                margin-top: 26px;
                padding-right: 20px;
                box-sizing: border-box;
            }
            .gg {
                top: 50px;
                .title {
                    font-size: 20px;
                    margin-top: 26px;
                }
                .button {
                    padding: 6px 15px;
                    margin-top: 20px;
                }
            }
            
        }
        .flashImg {
            height: 40vh;
        }
    }
}
</style>